import { motion } from 'framer-motion';

const AboutUs = () => (
  <section>
   
  </section>
);

export default AboutUs;
